export function getKeyboardFocusableElements(
  element: HTMLElement | ShadowRoot
) {
  return [
    ...element.querySelectorAll(
      'a:not([style*="display: none"]), button, input, textarea, select, summary,[tabindex]:not([tabindex="-1"])'
    ),
  ].filter(el => !el.hasAttribute('disabled')) as Array<HTMLElement>;
}
export function getKeyboardFocusableElementsFromArray(
  elements: Array<HTMLElement | ShadowRoot | null>
) {
  let focusableElements: Array<HTMLElement> = [];
  elements.forEach(element => {
    if (!element) {
      return;
    }
    const newFocusableElements: Array<HTMLElement> =
      getKeyboardFocusableElements(element);
    // Combine arrays removing duplicates.
    focusableElements = [
      ...new Set([...focusableElements, ...newFocusableElements]),
    ];
  });
  return focusableElements;
}

export const trapFocus = (elements: Array<HTMLElement | ShadowRoot | null>) => {
  const focusableElements = getKeyboardFocusableElementsFromArray(elements);
  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];
  firstFocusableElement.focus();

  const firstKeyListener = (event: KeyboardEvent) => {
    if (event.key === 'Tab' && event.shiftKey) {
      event.preventDefault();
      lastFocusableElement.focus();
    }
  };

  const lastKeyListener = (event: KeyboardEvent) => {
    if (event.key === 'Tab' && event.shiftKey === false) {
      event.preventDefault();
      firstFocusableElement.focus();
    }
  };

  firstFocusableElement.addEventListener('keydown', firstKeyListener);
  lastFocusableElement.addEventListener('keydown', lastKeyListener);

  // TODO add removeEventListener for firstKeyListener and lastKeyListener
  // that can be called from component
};
